import { render, staticRenderFns } from "./detailRekapitulasiEvaluasi.vue?vue&type=template&id=20fad5a8"
import script from "./detailRekapitulasiEvaluasi.vue?vue&type=script&lang=js"
export * from "./detailRekapitulasiEvaluasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports